export default {"src":"/_next/static/media/paint_ball.c155d8db.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};